import { useContext } from "react";
import { LanguageContext } from "../../../../../context/LanguageContext";
import { Box } from "@mui/material";
import { ParagraphText } from "../../../../../Libraries";
import styles from "./../AllTransaction.module.css";

const TableHeader = () => {
  const [I18n] = useContext(LanguageContext);
  return (
    <Box className="invoiceListTableHeader accountTableHeaderMain">
      <Box className={`invListTableHeaderCol textLeft ${styles.statementDurationCol}`}>
        <ParagraphText
          className={"fontSize12 fontWeight500 newLightColor"}
          key={I18n.duration}
        >
          {I18n.duration}{" "}
        </ParagraphText>
      </Box>

      <Box className={`invListTableHeaderCol textRight ${styles.statementActionCol}`}>
        <ParagraphText
          className={"fontSize12 fontWeight500 newLightColor textRight"}
          key={I18n.action}
        >
          {I18n.action}{" "}
        </ParagraphText>
      </Box>
    </Box>
  );
};

export default TableHeader;
